import { intent_labels } from '$tablet-app/src/app/chat/intent_labels';
import { AppStateSlice } from '$tablet-app/src/app/stores/app_state';
import { append, getLast10Records } from '@akin-home/arrays';
import { pastWithinLast20Seconds } from '../../common/actions';
import { EventOccurenceStore } from './types';

export const createEventOccurenceStore: AppStateSlice<EventOccurenceStore> = (
  set,
  get
) => ({
  todays_events: [],

  triggered_event_start_ids: [],
  triggered_event_end_ids: [],

  loadTodaysEvents(todays_events) {
    set({ todays_events });
  },

  startEventOccurenceTimers() {
    if (get().event_start_timer_id) return; // Timers already initialized. Just return

    set({
      event_start_timer_id: setInterval(() => {
        const {
          todays_events,
          triggered_event_start_ids,
          sendChatBackgroundMessage,
        } = get();

        const just_started_events = todays_events.filter(
          ({ start, id }) =>
            pastWithinLast20Seconds(start) &&
            !triggered_event_start_ids.includes(id)
        );

        if (just_started_events.length) {
          const event = just_started_events[0];

          set({
            triggered_event_start_ids: getLast10Records(
              append(triggered_event_start_ids, event.id)
            ),
          });

          sendChatBackgroundMessage(intent_labels.event_start, {
            context: {
              event: {
                id: event.id,
                title: event.title,
                start: event.start.toISOString(),
                end: event.end.toISOString(),
              },
            },
          });
        }
      }, 5000),

      event_end_timer_id: setInterval(() => {
        const {
          todays_events,
          triggered_event_end_ids,
          sendChatBackgroundMessage,
        } = get();

        const just_started_events = todays_events.filter(
          ({ end, id }) =>
            pastWithinLast20Seconds(end) &&
            !triggered_event_end_ids.includes(id)
        );

        if (just_started_events.length) {
          const event = just_started_events[0];

          set({
            triggered_event_start_ids: getLast10Records(
              append(triggered_event_end_ids, event.id)
            ),
          });

          sendChatBackgroundMessage(intent_labels.event_end, {
            context: {
              event: {
                id: event.id,
                title: event.title,
                start: event.start.toISOString(),
                end: event.end.toISOString(),
              },
            },
          });
        }
      }, 10000),
    });
  },
});
